import axios from 'axios'

const state = {
  countItems: []
}

const getters = {
  getCountItems: (state) => state.countItems,
  getActiveCountItems: (state) => state.countItems.filter(item => item.is_active),
  getCountItemsByCategory: (state) => {
    const grouped = {}
    state.countItems.forEach(item => {
      const catName = item.category_name || 'Uncategorized'
      if (!grouped[catName]) {
        grouped[catName] = { name: catName, category_id: item.category, items: [] }
      }
      grouped[catName].items.push(item)
    })
    return Object.values(grouped)
  }
}

const mutations = {
  setCountItems(state, items) {
    state.countItems = items
  },
  addCountItem(state, item) {
    state.countItems.push(item)
  },
  updateCountItemInList(state, updatedItem) {
    const index = state.countItems.findIndex(i => i.id === updatedItem.id)
    if (index !== -1) {
      state.countItems.splice(index, 1, updatedItem)
    }
  },
  removeCountItem(state, id) {
    state.countItems = state.countItems.filter(i => i.id !== id)
  }
}

const actions = {
  getCountItems(context) {
    return axios.get('/api/count-items/')
      .then(response => {
        context.commit('setCountItems', response.data)
      })
      .catch(e => { console.log(e) })
  },
  getAllCountItems(context) {
    return axios.get('/api/count-items/?all=1')
      .then(response => {
        context.commit('setCountItems', response.data)
      })
      .catch(e => { console.log(e) })
  },
  createCountItem(context, payload) {
    return axios.post('/api/count-items/', payload)
      .then(response => {
        context.commit('addCountItem', response.data)
        return response.data
      })
      .catch(e => { console.log(e) })
  },
  updateCountItem(context, payload) {
    return axios.patch(`/api/count-items/${payload.id}/`, payload)
      .then(response => {
        context.commit('updateCountItemInList', response.data)
        return response.data
      })
      .catch(e => { console.log(e) })
  },
  deleteCountItem(context, payload) {
    return axios.delete(`/api/count-items/${payload.id}/`)
      .then(() => {
        context.commit('removeCountItem', payload.id)
      })
      .catch(e => { console.log(e) })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
